module.exports = __webpack_public_path__ + "img/avatar-2.1593f952.svg";